(function() {
    'use strict';

    angular.module('conferencesApp').service('Session', function ($resource, moment, WORLDSKILLS_API_CONFERENCES) {

        var dateTimeFormat = 'DD.MM.YYYY HH:mm';

        function transformRequest(data) {
            var session = angular.copy(data);
            if (session.start) {
                session.start = moment.utc(session.start, dateTimeFormat).subtract(session.conference.utc_offset, 'seconds').format();
            } else {
                session.start = null;
            }
            if (session.end) {
                session.end = moment.utc(session.end, dateTimeFormat).subtract(session.conference.utc_offset, 'seconds').format();
            } else {
                session.end = null;
            }
            return angular.toJson(session);
        }

        function transformResponse(data) {
            if (angular.isString(data)) {
                data = angular.fromJson(data);
                if (data.start) {
                    data.start = moment(data.start).utcOffset(data.conference.utc_offset/60).format(dateTimeFormat);
                }
                if (data.end) {
                    data.end = moment(data.end).utcOffset(data.conference.utc_offset/60).format(dateTimeFormat);
                }
            }
            return data;
        }

        return $resource(WORLDSKILLS_API_CONFERENCES + '/sessions/:id', {
            id: '@id'
        }, {
            get: {
                method: 'GET',
                transformResponse: transformResponse
            },
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT',
                transformRequest: transformRequest,
                transformResponse: transformResponse
            },
            save: {
                method: 'POST',
                transformRequest: transformRequest,
                transformResponse: transformResponse
            }
        });
    });

    angular.module('conferencesApp').service('SessionSpeaker', function($resource, WORLDSKILLS_API_CONFERENCES) {
        return $resource(WORLDSKILLS_API_CONFERENCES + '/sessions/:sessionId/speakers/:speakerId', {
        }, {
            update: {
                method: 'PUT'
            }
        });
    });

    angular.module('conferencesApp').service('SessionFile', function($resource, WORLDSKILLS_API_CONFERENCES) {
        return $resource(WORLDSKILLS_API_CONFERENCES + '/session_files/:id', {
            id: '@id'
        }, {
            update: {
                method: 'PUT',
            },
        });
    });

})();
